import * as React from "react";
import { ResponsivePopover } from "@/components/ui/responsive-popover";
import { cn } from "@/lib/utils";
import { ResponsiveCommandSelectList } from "./ResponsiveCommandSelectList";

interface ResponsiveCommandSelectDesktopProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  triggerWidth: number | null;
  title: string;
  highZIndex?: boolean;
  trigger: React.ReactNode;
  listProps: React.ComponentProps<typeof ResponsiveCommandSelectList>;
  /** When true, open the dropdown in a centered dialog instead of anchor-based popover */
  centerOnScreen?: boolean;
}

export function ResponsiveCommandSelectDesktop({
  open,
  onOpenChange,
  triggerWidth,
  title,
  highZIndex,
  trigger,
  listProps,
  centerOnScreen = false,
}: ResponsiveCommandSelectDesktopProps) {
  const [isInDialog, setIsInDialog] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      // Check if we're inside a dialog
      const dialogContent = document.querySelector("[data-slot=\"dialog-content\"]");
      setIsInDialog(!!dialogContent);
    }
  }, [open]);

  return (
    <div className="relative w-full">
      <ResponsivePopover
        open={open}
        onOpenChange={onOpenChange}
        content={
          <div
            className="max-h-[60vh] overflow-y-auto overflow-x-visible"
            style={
              triggerWidth != null && !centerOnScreen
                ? {
                    minWidth: `${triggerWidth}px`,
                    width: "max-content",
                    maxWidth: "min(90vw, 420px)",
                  }
                : { minWidth: "200px", width: "max-content", maxWidth: "min(90vw, 420px)" }
            }
          >
            <ResponsiveCommandSelectList {...listProps} />
          </div>
        }
        title={title}
        className={cn("p-0 max-w-none", highZIndex && "z-99999")}
        align="start"
        popoverSide="bottom"
        offset={12}
        withinPortal={!isInDialog}
        asChild={true}
        centerOnScreen={centerOnScreen}
      >
        {trigger}
      </ResponsivePopover>
    </div>
  );
}
